/**
 * Photoset Studio  -  claim-card grid (HARD LOCK 2026-09-18)
 * Staging theme #158783176926 |  /pages/photoset-studio
 * Search + cost filters + sort (no spicy UI ever)
 */
(() => {
  const root = document.getElementById("kl-photoset-studio");
  if (!root || root.dataset.booted) return;
  root.dataset.booted = "1";

  const grid = root.querySelector("[data-ps-grid]");
  const lede = null; // engineer catalog-count lede removed — warm explainer is liquid-only
  const balanceEl = root.querySelector("[data-ps-balance]");
  const toastEl = root.querySelector("[data-ps-toast]");
  const inAppTip = root.querySelector("[data-ps-inapp]");
  const preview = root.querySelector("[data-ps-preview]");
  const previewTitle = root.querySelector("[data-ps-preview-title]");
  const previewSub = root.querySelector("[data-ps-preview-sub]");
  const previewGrid = root.querySelector("[data-ps-preview-grid]");
  const previewClose = root.querySelector("[data-ps-preview-close]");
  const searchInput = root.querySelector("[data-ps-search]");
  const sortSelect = root.querySelector("[data-ps-sort]");
  const countEl = root.querySelector("[data-ps-count]");
  const costChips = Array.from(root.querySelectorAll("[data-ps-cost]"));
  const loginUrl = root.dataset.loginUrl || "/account/login";
  const catalogUrl = root.dataset.catalogUrl || "/apps/katiecoins/photoset-catalog";
  const coverBase = root.dataset.coverBase || "";
  const previewBase = root.dataset.previewBase || "";
  function resolveCover(set) {
    const direct = set.cover_url || set.preview_url;
    if (direct) return direct;
    const asset = set.cover_asset;
    if (!asset || !coverBase) return "";
    return coverBase.replace(/ps-c-001\.jpg/i, asset);
  }
  function resolvePreviewUrl(f) {
    if (!f) return "";
    if (f.url) return f.url;
    const asset = f.asset;
    if (!asset) return "";
    const base = previewBase || coverBase;
    if (!base) return "";
    if (previewBase) return previewBase.replace(/ps-p-001-01\.jpg/i, asset);
    return coverBase.replace(/ps-c-001\.jpg/i, asset);
  }
  const redeemUrl = root.dataset.redeemUrl || "/apps/katiecoins/redeem-photoset";
  const downloadsUrl = root.dataset.downloadsUrl || "/apps/katiecoins/downloads";
  const purseUrl = root.dataset.purseUrl || "/apps/katiecoins/purse";
  const isLoggedIn = root.dataset.loggedIn === "1";

  /** @type {Record<string, any>} */
  const setsById = {};
  /** @type {any[]} full catalog in original Featured order */
  let catalogSets = [];
  let filterCost = "all";
  let filterQuery = "";
  let sortMode = "featured";
  let searchTimer = null;
  let toastTimer = null;

  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => {
      toastEl.hidden = true;
    }, 3200);
  }

  function esc(s) {
    return String(s ?? "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function formatCoins(n) {
    const num = Number(n) || 0;
    return `${num.toLocaleString("en-US")} KatieCoins`;
  }

  function formatBalance(n) {
    const num = Number(n) || 0;
    return `my balance: ${num.toLocaleString("en-US")} KatieCoins`;
  }

  function cleanTitle(t) {
    return String(t ?? "")
      .replace(/\ - |\ - /g, " ")
      .replace(/\s{2,}/g, " ")
      .trim();
  }

  function formatStills(n, zipSize) {
    const count = Number(n) || 0;
    const base = count === 1 ? "1 still" : `${count} stills`;
    if (zipSize) return `${base} (${zipSize})`;
    return base;
  }

  function isInAppBrowser() {
    const ua = navigator.userAgent || "";
    return /FBAN|FBAV|Instagram|Line\/|Twitter|LinkedInApp|Snapchat|Pinterest|TikTok|MicroMessenger|WhatsApp/i.test(
      ua
    );
  }

  function showInAppTip() {
    if (inAppTip && isInAppBrowser()) inAppTip.hidden = false;
  }

  function cardHtml(set) {
    const coverSrc = resolveCover(set);
    const cover = coverSrc
      ? `<img class="kl-ps-cover" src="${esc(coverSrc)}" alt="" loading="lazy" />`
      : `<div class="kl-ps-cover-fallback">No cover yet</div>`;
    const owned = !!set.owned;
    const primary = owned
      ? `<button type="button" class="kl-ps-btn kl-ps-btn-download" data-download="${esc(set.set_id || set.id)}">Download</button>`
      : `<button type="button" class="kl-ps-btn kl-ps-btn-redeem" data-redeem="${esc(set.set_id || set.id)}">Redeem</button>`;
    return `
      <article class="kl-ps-card" data-set-id="${esc(set.set_id || set.id)}">
        ${cover}
        <div class="kl-ps-card-body">
          <p class="kl-ps-coin-cost">${esc(formatCoins(set.coin_cost))}</p>
          <h2 class="kl-ps-card-title">${esc(cleanTitle(set.title))}</h2>
          <p class="kl-ps-stills">${esc(formatStills(set.still_count, set.zip_size))}</p>
          ${owned ? '<p class="kl-ps-owned">You own this set</p>' : ""}
          <div class="kl-ps-card-actions">
            <button type="button" class="kl-ps-btn kl-ps-btn-preview" data-preview="${esc(set.set_id || set.id)}">Preview</button>
            ${primary}
          </div>
        </div>
      </article>`;
  }

  function matchesSearch(set, q) {
    if (!q) return true;
    const hay = `${set.title || ""} ${set.tier || ""}`.toLowerCase();
    return hay.includes(q);
  }

  function matchesCost(set) {
    if (filterCost === "all") return true;
    return Number(set.coin_cost) === Number(filterCost);
  }

  function sortedSets(list) {
    const out = list.slice();
    if (sortMode === "featured") return out;
    if (sortMode === "cost-asc") {
      out.sort((a, b) => (Number(a.coin_cost) || 0) - (Number(b.coin_cost) || 0));
    } else if (sortMode === "cost-desc") {
      out.sort((a, b) => (Number(b.coin_cost) || 0) - (Number(a.coin_cost) || 0));
    } else if (sortMode === "az") {
      out.sort((a, b) => cleanTitle(a.title).localeCompare(cleanTitle(b.title), "en", { sensitivity: "base" }));
    } else if (sortMode === "za") {
      out.sort((a, b) => cleanTitle(b.title).localeCompare(cleanTitle(a.title), "en", { sensitivity: "base" }));
    } else if (sortMode === "stills") {
      out.sort((a, b) => (Number(b.still_count) || 0) - (Number(a.still_count) || 0));
    }
    return out;
  }

  function updateCount(shown, total) {
    if (!countEl) return;
    countEl.textContent = `Showing ${shown} of ${total}`;
  }

  function renderGrid() {
    if (!grid) return;
    const q = filterQuery.trim().toLowerCase();
    const filtered = catalogSets.filter((s) => matchesSearch(s, q) && matchesCost(s));
    const visible = sortedSets(filtered);
    updateCount(visible.length, catalogSets.length);
    if (!catalogSets.length) {
      grid.innerHTML = `<div class="kl-ps-empty">No photosets in catalog yet.</div>`;
      return;
    }
    if (!visible.length) {
      grid.innerHTML = `<div class="kl-ps-empty">No photosets match your search or filters. Try clearing search or picking All.</div>`;
      return;
    }
    grid.innerHTML = visible.map(cardHtml).join("");
  }

  function setActiveCostChip(value) {
    filterCost = value;
    costChips.forEach((btn) => {
      const on = btn.getAttribute("data-ps-cost") === value;
      btn.classList.toggle("is-active", on);
      btn.setAttribute("aria-pressed", on ? "true" : "false");
    });
  }

  function openPreview(setId) {
    const set = setsById[setId];
    if (!set || !preview) return;
    const files = Array.isArray(set.preview_stills) ? set.preview_stills : [];
    if (previewTitle) previewTitle.textContent = cleanTitle(set.title || setId);
    if (previewSub) {
      previewSub.textContent = `${formatCoins(set.coin_cost)} | ${formatStills(files.length || set.still_count, set.zip_size)}`;
    }
    if (previewGrid) {
      if (!files.length) {
        const coverSrc = resolveCover(set);
        if (coverSrc) {
          previewGrid.innerHTML = `<figure><img class="kl-ps-preview-still" src="${esc(coverSrc)}" alt="" /></figure>`;
        } else {
          previewGrid.innerHTML = `<div class="kl-ps-empty">Preview stills coming soon - Media wires full galleries next.</div>`;
        }
      } else {
        previewGrid.innerHTML = files.map((f) => `<figure><img src="${esc(resolvePreviewUrl(f))}" alt="" loading="lazy" /></figure>`).join("");
      }
    }
    preview.hidden = false;
    // iOS-safe body lock: position fixed (overflow:hidden alone breaks nested scroll)
    if (!document.body.dataset.klPsScrollY) {
      document.body.dataset.klPsScrollY = String(window.scrollY || window.pageYOffset || 0);
    }
    document.body.style.position = "fixed";
    document.body.style.top = `-${document.body.dataset.klPsScrollY}px`;
    document.body.style.left = "0";
    document.body.style.right = "0";
    document.body.style.width = "100%";
    document.body.style.overflow = "hidden";
    // Start at top of gallery so first still is visible; user scrolls overlay for the rest
    preview.scrollTop = 0;
    try { preview.focus({ preventScroll: true }); } catch (_) {}
  }

  function closePreview() {
    if (!preview) return;
    preview.hidden = true;
    if (previewGrid) previewGrid.innerHTML = "";
    const y = Number(document.body.dataset.klPsScrollY || 0);
    delete document.body.dataset.klPsScrollY;
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.left = "";
    document.body.style.right = "";
    document.body.style.width = "";
    document.body.style.overflow = "";
    window.scrollTo(0, y);
  }

  async function loadBalance() {
    if (!balanceEl) return;
    if (balanceEl.getAttribute("data-ps-demo") === "1") {
      const demo = Number(String(balanceEl.textContent || "1000").replace(/[^0-9]/g, "")) || 1000;
      balanceEl.textContent = formatBalance(demo);
      return;
    }
    if (!isLoggedIn) {
      balanceEl.textContent = "Sign in";
      return;
    }
    balanceEl.textContent = "...";
    try {
      const res = await fetch(purseUrl, { credentials: "same-origin" });
      const text = await res.text();
      if (!text || !String(text).trim()) throw new Error("empty");
      const data = JSON.parse(text);
      const bal = data.katieCoins ?? data.balance ?? data.katie_coins ?? data.coins;
      if (bal != null) balanceEl.textContent = formatBalance(bal);
      else balanceEl.textContent = "-";
    } catch (_) {
      balanceEl.textContent = "-";
    }
  }

  async function loadCatalog() {
    try {
      const res = await fetch(catalogUrl, { credentials: "same-origin" });
      const text = await res.text();
      if (!text || !String(text).trim()) {
        throw new Error("Catalog response empty (" + res.status + "). Try refresh.");
      }
      let data;
      try { data = JSON.parse(text); } catch (e) {
        throw new Error("Catalog not JSON (" + res.status + ")");
      }
      const sets = data.items || data.sets || [];
      Object.keys(setsById).forEach((k) => delete setsById[k]);
      catalogSets = sets.slice();
      catalogSets.forEach((s) => {
        const id = s.set_id || s.id;
        setsById[id] = s;
      });
      renderGrid();
    } catch (err) {
      catalogSets = [];
      if (grid) grid.innerHTML = `<div class="kl-ps-empty">${esc(err.message || err)}</div>`;
      updateCount(0, 0);
    }
  }

  async function doRedeem(setId) {
    if (!isLoggedIn) {
      window.location.href = loginUrl;
      return;
    }
    const set = setsById[setId];
    if (!set) return;
    const cost = formatCoins(set.coin_cost);
    const title = cleanTitle(set.title);
    if (!window.confirm(`Use ${cost} to unlock ${title}? You'll keep re-download access in My Downloads.`)) {
      return;
    }
    try {
      const res = await fetch(redeemUrl, {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ set_id: setId }),
      });
      const data = await res.json().catch(() => ({}));
      if (res.status === 503 && data.error === "photoset_redeem_disabled") {
        toast("Photoset redeem not enabled on staging yet.");
        return;
      }
      if (res.status === 401 || data.error === "auth_required") {
        window.location.href = loginUrl;
        return;
      }
      if (res.status === 402 || data.error === "insufficient_coins") {
        toast("Not enough KatieCoins yet. Keep playing parlor games to earn more.");
        return;
      }
      if (res.status === 403 || data.error === "age_required") {
        toast("Age confirmation needed.");
        return;
      }
      if (!res.ok && !data.ok) {
        toast(data.message || data.error || "Redeem failed.");
        return;
      }
      set.owned = true;
      if (data.r2_pending || data.error === "r2_pending") {
        toast("Unlocked  -  download file pending (Media R2). See My Downloads.");
      } else if (data.download_url) {
        showInAppTip();
        toast(data.already_owned ? "You already own this  -  opening download." : "Photoset unlocked  -  download ready.");
        if (!isInAppBrowser()) window.location.href = data.download_url;
      } else {
        toast(data.message || "Photoset unlocked  -  open My Downloads.");
      }
      await loadBalance();
      await loadCatalog();
    } catch (err) {
      toast(String(err.message || err));
    }
  }

  async function doDownload(setId) {
    if (!isLoggedIn) {
      window.location.href = loginUrl;
      return;
    }
    showInAppTip();
    if (isInAppBrowser()) {
      toast("Open in Safari or Chrome to save the zip to Files / Downloads.");
      return;
    }
    try {
      const res = await fetch(`${downloadsUrl}?set_id=${encodeURIComponent(setId)}`, {
        credentials: "same-origin",
      });
      const data = await res.json().catch(() => ({}));
      const item = (data.items || [])[0];
      if (item?.r2_pending || data.r2_ready === false) {
        toast("Download pending  -  Media is wiring the zip bucket.");
        return;
      }
      if (item?.download_url) {
        toast("Saved to Files  -  open anytime.");
        window.location.href = item.download_url;
        return;
      }
      toast(item?.mint_error || data.error || "Download not ready yet.");
    } catch (err) {
      toast(String(err.message || err));
    }
  }

  grid?.addEventListener("click", (e) => {
    const previewBtn = e.target.closest("[data-preview]");
    if (previewBtn) {
      openPreview(previewBtn.getAttribute("data-preview"));
      return;
    }
    const redeemBtn = e.target.closest("[data-redeem]");
    if (redeemBtn) {
      doRedeem(redeemBtn.getAttribute("data-redeem"));
      return;
    }
    const dlBtn = e.target.closest("[data-download]");
    if (dlBtn) {
      doDownload(dlBtn.getAttribute("data-download"));
    }
  });

  searchInput?.addEventListener("input", () => {
    clearTimeout(searchTimer);
    searchTimer = setTimeout(() => {
      filterQuery = searchInput.value || "";
      renderGrid();
    }, 150);
  });

  costChips.forEach((btn) => {
    btn.addEventListener("click", () => {
      setActiveCostChip(btn.getAttribute("data-ps-cost") || "all");
      renderGrid();
    });
  });

  sortSelect?.addEventListener("change", () => {
    sortMode = sortSelect.value || "featured";
    renderGrid();
  });

  previewClose?.addEventListener("click", closePreview);
  preview?.addEventListener("click", (e) => {
    if (e.target === preview) closePreview();
  });
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && preview && !preview.hidden) closePreview();
  });

  showInAppTip();
  loadBalance();
  loadCatalog();
})();
